import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'auto-complete-input',
  templateUrl: './auto-complete-input.component.html',
  styleUrl: './auto-complete-input.component.scss'
})
export class AutoCompleteInputComponent  {
  @Input() form!: FormGroup;
  @Input() label!: string;
  @Input() options: string[] = [];
  @Input() data: any[] = [];
  @Input() controlName: string = '';
  @Output() optionSelected = new EventEmitter<any>();
  
  searchTerm: string = '';
  filteredOptions: string[] = this.options;
  showDropdown: boolean = false;
  focusedControls: { [key: string]: boolean } = {}; // Map to track focus state
  private optionJustSelected = false;

  ngOnInit() {
    const control = this.form.get(this.controlName);

    // Inicializa el filtro y escucha cambios en el control
    this.filterOptions(control?.value || '');
    control?.valueChanges.subscribe(value => {
      this.filterOptions(value || '');
    });
    this.showDropdown = false;
  }

  onInput() {
    const control = this.form.get(this.controlName);
    this.filterOptions(control?.value);
  }

  public isValidField(field: string) {
    const control = this.form.get(field);
    return control && control.errors && (control.dirty || control.touched);
  }

  filterOptions(value: string = '') {
    if (!value) {
      this.filteredOptions = [];
      this.showDropdown = false;
      return;
    }

    this.filteredOptions = this.options.filter(option =>
      option.toLowerCase().includes(value.toLowerCase())
    );
    this.showDropdown = this.filteredOptions.length > 0;
  }

  selectOption(option: string) {
    this.optionJustSelected = true;
    const control = this.form.get(this.controlName);
    control?.setValue(option);
    this.showDropdown = false;

    const selectedObject = this.data.find(
      item =>
        item.SURACiudadDepartamento__c === option ||
        item === option
    );
    this.optionSelected.emit(selectedObject);
  }

  hideDropdown() {
    setTimeout(() => {
      if (!this.options.includes(this.searchTerm)) {

        this.searchTerm = ''; // Clear input if no valid option is selected
        this.form.get(this.controlName)?.setErrors({ invalidOption: true }); // Mark the form control as invalid
      }
      this.showDropdown = false;
    }, 200);
  }

  onFocus() {
    const control = this.form.get(this.controlName);
    this.filterOptions(control?.value || '');
    this.showDropdown = this.filteredOptions.length > 0;
    this.focusedControls[this.controlName] = true;
  }

  onBlur() {
    this.focusedControls[this.controlName] = false;

    setTimeout(() => {

      if (this.optionJustSelected) {
        this.optionJustSelected = false;
        this.showDropdown = false;
        return;
      }

      const control = this.form.get(this.controlName);
      const isValid = this.options.includes(control?.value || '');

      if (!isValid) {
        this.searchTerm = '';
        control?.setValue('');
        control?.setErrors({ invalidOption: true });
      } else {
        control?.setErrors(null);
      }

      this.showDropdown = false;
    }, 200);
  }


  isFocused(controlName: string): boolean {
    return !!this.focusedControls[controlName]; // Return focus state
  }
}
